
<div class="text-right">
  <a mat-dialog-close class="cursor-pointer">
    <fa-icon icon="times-circle" size="lg"></fa-icon>
  </a>
</div>
<div class="flex flex-col gap-6 items-center">
  <app-avatar [user]="data.user" size="xl" >
  </app-avatar>

  <p class="text-lg">{{data.user.givenName}}</p>

</div>

